<template>
  <svg
    class="app-icon"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      v-for="path in iconPaths"
      :key="path.d || path"
      :d="path.d || path"
      :fill="path.fill ? 'currentColor' : 'none'"
      :stroke="path.fill ? 'none' : 'currentColor'"
      :fill-rule="path.fillRule"
      :clip-rule="path.fillRule"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
const icons = {
  bug: [
    {
      d: 'M8.2 5.7 6.55 4.05a1 1 0 1 1 1.4-1.42L10.05 4.7h3.9l2.1-2.07a1 1 0 1 1 1.4 1.42L15.8 5.7A5.4 5.4 0 0 1 17.3 9H19a1 1 0 1 1 0 2h-1.55v2H19a1 1 0 1 1 0 2h-1.7A5.35 5.35 0 0 1 12 19.8 5.35 5.35 0 0 1 6.7 15H5a1 1 0 1 1 0-2h1.55v-2H5a1 1 0 1 1 0-2h1.7a5.4 5.4 0 0 1 1.5-3.3ZM9.2 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5.6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM9 14.8h6v-2H9v2Z',
      fill: true,
      fillRule: 'evenodd'
    }
  ],
  'arrow-right': ['M5 12h14', 'm13 6 6 6-6 6'],
  bell: [
    {
      d: 'M12 3.4a5.6 5.6 0 0 0-5.6 5.6v2.78c0 .74-.24 1.46-.68 2.06L4.2 15.9a1.15 1.15 0 0 0 .92 1.84h13.76a1.15 1.15 0 0 0 .92-1.84l-1.52-2.06a3.45 3.45 0 0 1-.68-2.06V9A5.6 5.6 0 0 0 12 3.4Zm-2.2 15.4a2.35 2.35 0 0 0 4.4 0h-4.4Z',
      fill: true,
      fillRule: 'evenodd'
    }
  ],
  chevron: ['m6 9 6 6 6-6'],
  contact: [
    {
      d: 'M7 3.5h10A2.5 2.5 0 0 1 19.5 6v14.5L12 17l-7.5 3.5V6A2.5 2.5 0 0 1 7 3.5Zm2 5a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2Zm3 0a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2Zm3 0a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2Z',
      fill: true
    }
  ],
  code: ['m8 9-4 3 4 3', 'm16 9 4 3-4 3', 'm14 5-4 14'],
  home: [
    {
      d: 'M3.5 11.2 12 4l8.5 7.2v8.1c0 .66-.54 1.2-1.2 1.2h-4.1v-5.4H8.8v5.4H4.7c-.66 0-1.2-.54-1.2-1.2v-8.1Z',
      fill: true
    }
  ],
  heart: [
    {
      d: 'M12 20.5s-8.5-4.9-8.5-11.1A4.9 4.9 0 0 1 12 6.1a4.9 4.9 0 0 1 8.5 3.3c0 6.2-8.5 11.1-8.5 11.1Z',
      fill: true
    }
  ],
  headset: [
    'M4 12a8 8 0 0 1 16 0v4',
    'M4 13.5v2.2A2.3 2.3 0 0 0 6.3 18H8v-6H6.3A2.3 2.3 0 0 0 4 14.3',
    'M20 13.5v2.2a2.3 2.3 0 0 1-2.3 2.3H16v-6h1.7a2.3 2.3 0 0 1 2.3 2.3',
    'M16 18c0 1.7-1.35 3-3 3h-1'
  ],
  crown: [
    {
      d: 'M4.1 7.15c.32-.22.74-.2 1.04.05l3.05 2.56 3.02-6.08a.88.88 0 0 1 1.58 0l3.02 6.08 3.05-2.56a.88.88 0 0 1 1.43.8l-1.5 10.35a1.35 1.35 0 0 1-1.34 1.16H6.55a1.35 1.35 0 0 1-1.34-1.16L3.71 8a.88.88 0 0 1 .39-.85Zm3.34 9.78h9.12l.75-5.18-1.5 1.26a1.25 1.25 0 0 1-1.92-.42L12 8.8l-1.89 3.79a1.25 1.25 0 0 1-1.92.42l-1.5-1.26.75 5.18Z',
      fill: true,
      fillRule: 'evenodd'
    }
  ],
  dashboard: [
    {
      d: 'M4.8 4h5.45c.44 0 .8.36.8.8v6.1c0 .44-.36.8-.8.8H4.8a.8.8 0 0 1-.8-.8V4.8c0-.44.36-.8.8-.8Zm8.95 0h5.45c.44 0 .8.36.8.8v3.4c0 .44-.36.8-.8.8h-5.45a.8.8 0 0 1-.8-.8V4.8c0-.44.36-.8.8-.8Zm0 8.3h5.45c.44 0 .8.36.8.8v6.1c0 .44-.36.8-.8.8h-5.45a.8.8 0 0 1-.8-.8v-6.1c0-.44.36-.8.8-.8ZM4.8 15h5.45c.44 0 .8.36.8.8v3.4c0 .44-.36.8-.8.8H4.8a.8.8 0 0 1-.8-.8v-3.4c0-.44.36-.8.8-.8Z',
      fill: true
    }
  ],
  discord: [
    {
      d: 'M19.27 5.33A17.2 17.2 0 0 0 15.02 4a.16.16 0 0 0-.17.08c-.18.32-.39.74-.53 1.07a15.86 15.86 0 0 0-4.75 0 10.5 10.5 0 0 0-.54-1.07A.16.16 0 0 0 8.86 4a17.15 17.15 0 0 0-4.25 1.33.14.14 0 0 0-.07.06C1.84 9.42 1.1 13.35 1.46 17.23c.01.06.04.12.09.15A17.3 17.3 0 0 0 6.76 20a.16.16 0 0 0 .18-.06c.4-.54.76-1.11 1.07-1.72a.16.16 0 0 0-.09-.22 11.4 11.4 0 0 1-1.63-.78.16.16 0 0 1-.02-.26c.11-.08.22-.17.32-.25a.15.15 0 0 1 .17-.02c3.43 1.56 7.13 1.56 10.52 0a.15.15 0 0 1 .17.02l.33.25a.16.16 0 0 1-.02.26c-.52.31-1.07.57-1.64.78a.16.16 0 0 0-.08.23c.32.6.68 1.17 1.07 1.71.04.06.11.08.18.06a17.25 17.25 0 0 0 5.22-2.62.16.16 0 0 0 .08-.15c.43-4.49-.73-8.38-3.23-11.84a.13.13 0 0 0-.07-.06ZM8.52 14.86c-1.03 0-1.88-.95-1.88-2.12 0-1.16.83-2.12 1.88-2.12 1.06 0 1.9.96 1.88 2.12 0 1.17-.83 2.12-1.88 2.12Zm6.96 0c-1.03 0-1.88-.95-1.88-2.12 0-1.16.83-2.12 1.88-2.12 1.06 0 1.9.96 1.88 2.12 0 1.17-.82 2.12-1.88 2.12Z',
      fill: true
    }
  ],
  instagram: [
    'M7 2.8h10A4.2 4.2 0 0 1 21.2 7v10a4.2 4.2 0 0 1-4.2 4.2H7A4.2 4.2 0 0 1 2.8 17V7A4.2 4.2 0 0 1 7 2.8Z',
    'M8.6 12a3.4 3.4 0 1 0 6.8 0 3.4 3.4 0 0 0-6.8 0Z',
    'M17.35 6.65h.01'
  ],
  tiktok: [
    'M14 3v11.1a4.9 4.9 0 1 1-4.9-4.9c.42 0 .82.05 1.2.15v2.9a2.05 2.05 0 1 0 1.7 2.02V3h2Z',
    'M14 3c.72 2.8 2.52 4.46 5 4.72v2.72c-2.08-.08-3.84-.82-5-2.08'
  ],
  x: ['M4 4l16 16', 'M20 4 4 20', 'M8.5 4H4l11.5 16H20L8.5 4Z'],
  youtube: [
    {
      d: 'M21.1 7.4a3.05 3.05 0 0 0-2.15-2.16C17.05 4.75 12 4.75 12 4.75s-5.05 0-6.95.49A3.05 3.05 0 0 0 2.9 7.4 31.8 31.8 0 0 0 2.4 12a31.8 31.8 0 0 0 .5 4.6 3.05 3.05 0 0 0 2.15 2.16c1.9.49 6.95.49 6.95.49s5.05 0 6.95-.49a3.05 3.05 0 0 0 2.15-2.16 31.8 31.8 0 0 0 .5-4.6 31.8 31.8 0 0 0-.5-4.6ZM10 15.15v-6.3L15.45 12 10 15.15Z',
      fill: true,
      fillRule: 'evenodd'
    }
  ],
  lock: ['M6 10V8a6 6 0 0 1 12 0v2', 'M5 10h14v10H5V10Z', 'M12 14v2'],
  logs: [
    'M7 3.5h7.5L19 8v12.5H7V3.5Z',
    'M14.5 3.5V8H19',
    'M9.5 11h7',
    'M9.5 14h7',
    'M9.5 17h4',
    'M4 13h6v5H4v-5Z'
  ],
  message: ['M4 5h16v10H9l-5 4V5Z'],
  info: [
    {
      d: 'M12 2.5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19Zm0 4.1a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm-1.15 5.05c0-.55.45-1 1-1h.3c.55 0 1 .45 1 1v5.3a1 1 0 1 1-2 0v-4.3h-.3a1 1 0 0 1-1-1Z',
      fill: true,
      fillRule: 'evenodd'
    }
  ],
  moon: [
    {
      d: 'M20.1 14.2A7.5 7.5 0 0 1 9.8 3.9a.55.55 0 0 0-.52-.92A9.45 9.45 0 1 0 21.02 14.72a.55.55 0 0 0-.92-.52Z',
      fill: true
    }
  ],
  megaphone: [
    {
      d: 'M4 10.5v3A2.5 2.5 0 0 0 6.5 16H8l1.8 3.15a1.55 1.55 0 0 0 2.85-1.2L11.5 16H13l6.2 2.6A1.3 1.3 0 0 0 21 17.4V6.6a1.3 1.3 0 0 0-1.8-1.2L13 8H6.5A2.5 2.5 0 0 0 4 10.5Zm9.5-.72 5.5-2.3v9.04l-5.5-2.3V9.78Z',
      fill: true,
      fillRule: 'evenodd'
    }
  ],
  sun: [
    {
      d: 'M12 7.2a4.8 4.8 0 1 1 0 9.6 4.8 4.8 0 0 1 0-9.6Z',
      fill: true
    },
    'M12 2.5v2',
    'M12 19.5v2',
    'M4.57 4.57l1.42 1.42',
    'M18.01 18.01l1.42 1.42',
    'M2.5 12h2',
    'M19.5 12h2',
    'M4.57 19.43l1.42-1.42',
    'M18.01 5.99l1.42-1.42'
  ],
  server: [
    {
      d: 'M4.8 4h14.4c.99 0 1.8.81 1.8 1.8v3.4c0 .99-.81 1.8-1.8 1.8H4.8C3.81 11 3 10.19 3 9.2V5.8C3 4.81 3.81 4 4.8 4Zm0 9h14.4c.99 0 1.8.81 1.8 1.8v3.4c0 .99-.81 1.8-1.8 1.8H4.8C3.81 20 3 19.19 3 18.2v-3.4c0-.99.81-1.8 1.8-1.8ZM7 7.5a1 1 0 1 0 0 .01V7.5Zm0 9a1 1 0 1 0 0 .01v-.01Z',
      fill: true,
      fillRule: 'evenodd'
    }
  ],
  shield: [
    {
      d: 'M12 2.5 20.5 6v5.75c0 5.3-3.58 8.86-8.5 9.75-4.92-.89-8.5-4.45-8.5-9.75V6L12 2.5Zm3.7 7.25a1 1 0 0 0-1.4-1.43l-3.25 3.19-1.35-1.33a1 1 0 0 0-1.4 1.43l2.05 2.02a1 1 0 0 0 1.4 0l3.95-3.88Z',
      fill: true,
      fillRule: 'evenodd'
    }
  ],
  resources: [
    {
      d: 'M12 2.75 15.15 8.85 21.25 12l-6.1 3.15L12 21.25l-3.15-6.1L2.75 12l6.1-3.15L12 2.75Zm0 4.65-1.75 3.38L6.87 12l3.38 1.75L12 17.13l1.75-3.38L17.13 12l-3.38-1.75L12 7.4Z',
      fill: true,
      fillRule: 'evenodd'
    }
  ],
  spark: ['M12 2v5', 'M12 17v5', 'M4.2 4.2l3.5 3.5', 'M16.3 16.3l3.5 3.5', 'M2 12h5', 'M17 12h5', 'M4.2 19.8l3.5-3.5', 'M16.3 7.7l3.5-3.5'],
  star: [
    {
      d: 'M12 3.2 14.78 8.83l6.22.9-4.5 4.39 1.06 6.18L12 17.38 6.44 20.3l1.06-6.18L3 9.73l6.22-.9L12 3.2Z',
      fill: true
    }
  ],
  status: [
    {
      d: 'M5.2 13.2a1.7 1.7 0 0 1 1.7 1.7v4.4a1.7 1.7 0 0 1-3.4 0v-4.4a1.7 1.7 0 0 1 1.7-1.7Zm6.8-8.7a1.7 1.7 0 0 1 1.7 1.7v13.1a1.7 1.7 0 0 1-3.4 0V6.2A1.7 1.7 0 0 1 12 4.5Zm6.8 4.5a1.7 1.7 0 0 1 1.7 1.7v8.6a1.7 1.7 0 0 1-3.4 0v-8.6A1.7 1.7 0 0 1 18.8 9Z',
      fill: true
    }
  ],
  team: [
    {
      d: 'M12 4.2a3.35 3.35 0 1 1 0 6.7 3.35 3.35 0 0 1 0-6.7Zm-6.2 2a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5Zm12.4 0a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5ZM12 12.7c3.1 0 5.6 1.8 5.6 4v1.5c0 .88-.72 1.6-1.6 1.6H8c-.88 0-1.6-.72-1.6-1.6v-1.5c0-2.2 2.5-4 5.6-4Zm-6.9.5c.56 0 1.1.08 1.6.23-1.2.9-1.95 2.06-1.95 3.27v1.5c0 .34.06.66.17.96H3.4c-.88 0-1.6-.72-1.6-1.6v-1.02c0-1.84 1.48-3.34 3.3-3.34Zm13.8 0c1.82 0 3.3 1.5 3.3 3.34v1.02c0 .88-.72 1.6-1.6 1.6h-1.52c.11-.3.17-.62.17-.96v-1.5c0-1.21-.75-2.37-1.95-3.27.5-.15 1.04-.23 1.6-.23Z',
      fill: true
    }
  ],
  ticket: [
    {
      d: 'M4.8 5h14.4c.99 0 1.8.81 1.8 1.8v3.35a2 2 0 0 0 0 3.7v3.35c0 .99-.81 1.8-1.8 1.8H4.8c-.99 0-1.8-.81-1.8-1.8v-3.35a2 2 0 0 0 0-3.7V6.8C3 5.81 3.81 5 4.8 5Zm5.2 2v10h2V7h-2Z',
      fill: true,
      fillRule: 'evenodd'
    }
  ]
}

export default {
  name: 'AppIcon',
  props: {
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    iconPaths() {
      return icons[this.name] || icons.spark
    }
  }
}
</script>
